import React from 'react'
import "./spinner.css";

const Spinner = () => {
  return (
    <div className="w-[100%] h-screen flex justify-center items-center">
        <div className='spinner'></div>
    </div>
  )
}

export default Spinner